import apiClient from './ApiClient';

// API to get employee report data
export const getEmployeeReport = async (filter = {}) => {
  try {
    const response = await apiClient.post('/api/Employee/report', filter);
    return response.data;
  } catch (error) {
    console.error("Error fetching employee report:", error);
    throw error;
  }
};

// API to export employee report to Excel
export const exportEmployeeReportToExcel = async (filter = {}) => {
  try {
    const response = await apiClient.post('/api/Employee/export-excel', filter, {
      responseType: 'blob'
    });
    
    // Create download link
    const url = window.URL.createObjectURL(new Blob([response.data]));
    const link = document.createElement('a');
    link.href = url;
    link.setAttribute('download', `EmployeeReport_${new Date().toISOString().slice(0,19).replace(/[-:]/g, '').replace('T', '_')}.xlsx`);
    document.body.appendChild(link);
    link.click();
    link.remove();
    window.URL.revokeObjectURL(url);
    
    return true;
  } catch (error) {
    console.error("Error exporting employee report:", error);
    throw error;
  }
};
